import CityStatus  from './CityStatus';

export default CityStatus;



// WEBPACK FOOTER //
// ./src/app/views/admin/cityStatus/index.js